import React from 'react';
var EmptySearchResult = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "empty-search-result" }, children);
};
export { EmptySearchResult };
//# sourceMappingURL=EmptySearchResult.js.map